var _INIT_TARGET_INVITATI, _InvitationStatusTabC;
import { InvitationGroupAcceptStatus, InvitationGroupStatus } from '@/api/affiliate/serv/oec_affiliate_invitation_api';
export var INIT_TARGET_INVITATION_NUMBER = (_INIT_TARGET_INVITATI = {}, _INIT_TARGET_INVITATI[InvitationGroupStatus.INVITATION_GROUP_STATUS_UNSPECIFIED] = 0, _INIT_TARGET_INVITATI[InvitationGroupStatus.INVITATION_GROUP_STATUS_LIVE] = 0, _INIT_TARGET_INVITATI[InvitationGroupStatus.INVITATION_GROUP_STATUS_EXPIRING] = 0, _INIT_TARGET_INVITATI[InvitationGroupStatus.INVITATION_GROUP_STATUS_DELETING] = 0, _INIT_TARGET_INVITATI[InvitationGroupStatus.INVITATION_GROUP_STATUS_ENDED] = 0, _INIT_TARGET_INVITATI);
export var InvitationStatusTabConfigs = (_InvitationStatusTabC = {}, _InvitationStatusTabC[InvitationGroupStatus.INVITATION_GROUP_STATUS_LIVE] = {
  title: {
    i18nKey: 'affiliate_target_invitation_list_tab_ongoing',
    defaultText: 'Ongoing'
  }
}, _InvitationStatusTabC[InvitationGroupStatus.INVITATION_GROUP_STATUS_EXPIRING] = {
  title: {
    i18nKey: 'affiliate_target_invitation_list_tab_expiring',
    defaultText: 'Expiring'
  },
  tooltip: {
    i18nKey: 'affiliate_target_invitation_list_tab_expiring_tooltip',
    defaultText: 'Invitations ending within the next 7 days. '
  }
}, _InvitationStatusTabC[InvitationGroupStatus.INVITATION_GROUP_STATUS_DELETING] = {
  title: {
    i18nKey: 'affiliate_target_invitation_list_tab_ending',
    defaultText: 'Ending'
  },
  tooltip: {
    i18nKey: 'affiliate_target_invitation_list_tab_ending_tooltip',
    defaultText: "Invitations you're in the process of canceling."
  }
}, _InvitationStatusTabC[InvitationGroupStatus.INVITATION_GROUP_STATUS_ENDED] = {
  title: {
    i18nKey: 'affiliate_target_invitation_list_tab_ended',
    defaultText: 'Ended'
  },
  tooltip: {
    i18nKey: 'affiliate_target_invitation_list_tab_ended_tooltip',
    defaultText: 'All completed collaboration invitations–including expired and canceled.'
  }
}, _InvitationStatusTabC);
export var InvitationStatusTabs = [InvitationGroupStatus.INVITATION_GROUP_STATUS_LIVE, InvitationGroupStatus.INVITATION_GROUP_STATUS_EXPIRING, InvitationGroupStatus.INVITATION_GROUP_STATUS_DELETING, InvitationGroupStatus.INVITATION_GROUP_STATUS_ENDED];
export var InvitationStatusTabsWithFlatFee = [InvitationGroupStatus.INVITATION_GROUP_STATUS_LIVE, InvitationGroupStatus.INVITATION_GROUP_STATUS_EXPIRING, InvitationGroupStatus.INVITATION_GROUP_STATUS_ENDED];
export var INIT_SEARCH_PARAMS = {
  query_items: [],
  filter_accept_status: InvitationGroupAcceptStatus.INVITATION_GROUP_ALL
};